import { cn } from "@/lib/utils";

// "The cell & the path" — a hex cell with three shrinking waypoints (the bee's
// waggle dance: passing on direction). Mirrors client/public/favicon.svg.
export function WaggleMark({ className, reversed = false }: { className?: string; reversed?: boolean }) {
  const cell = reversed ? "#FBF7FA" : "#4B0064";
  const dots = reversed ? "#4B0064" : "#FBF7FA";

  return (
    <svg viewBox="0 0 120 120" aria-hidden="true" className={cn("h-8 w-8 shrink-0", className)}>
      <polygon points="106,60 83,99.84 37,99.84 14,60 37,20.16 83,20.16" fill={cell} />
      <circle cx="38" cy="74" r="7" fill={dots} />
      <circle cx="58" cy="54" r="5" fill={dots} opacity="0.92" />
      <circle cx="76" cy="38" r="3.5" fill={dots} opacity="0.85" />
    </svg>
  );
}

export function WaggleLogo({ className, markClassName }: { className?: string; markClassName?: string }) {
  return (
    <span className={cn("flex items-center gap-2", className)}>
      <WaggleMark className={markClassName} />
      <span className="font-display text-lg font-bold tracking-tight text-foreground">Waggle</span>
    </span>
  );
}
